import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { alertError, parseMemberQRCode } from '../../Util/Util';
import subscriptionAPI from '../../middleware/subscriptionAPI';
import {
  SubscriptionServiceStatus,
  SubscriptionServiceTypeCode,
  SubscriptionServiceTypeCodeText,
} from '../../data/common';
import { find, forEach, groupBy, parseInt } from 'lodash';
import {
  Avatar,
  Button,
  Chip,
  CircularProgress,
  Divider,
} from '@material-ui/core';
import bonusAPI from '../../middleware/bonusAPI';
import ImageRoundedIcon from '@material-ui/icons/ImageRounded';
import SubscriptionServiceCard from '../../components/Subscriptions/SubscriptionServiceCard';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
  },
  memberInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  subscriptionServices: {
    marginTop: theme.spacing(2),
  },
  groupServices: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridColumnGap: '24px',
    gridRowGap: '24px',
  },
}));

const SubscriptionServices = (props) => {
  const { qrcode } = props;
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const [groupSubscriptionServices, setGroupSubscriptionServices] = useState();
  const [pageStep, setPageStep] = useState('select');
  const [member, setMember] = useState();

  useEffect(() => {
    const memberQRCode = parseMemberQRCode(qrcode);

    if (memberQRCode.member) {
      setIsLoading(true);

      bonusAPI
        .verifyQrcode(memberQRCode.member)
        .then(
          (response) => {
            setMember(response);
          },
          (error) => {
            alertError(error);
            setPageStep('fail');
          },
        )
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [qrcode]);

  useEffect(() => {
    subscriptionAPI
      .getServices(
        SubscriptionServiceTypeCode.ALL,
        SubscriptionServiceStatus.ONLINE,
      )
      .then(
        (response) => {
          const groupServices = groupBy(response, 'typeCode');
          setGroupSubscriptionServices(groupServices);
        },
        (error) => {
          alertError(error);
        },
      );
  }, []);

  useEffect(() => {
    if (groupSubscriptionServices && qrcode) {
      const memberQRCode = parseMemberQRCode(qrcode);

      if (memberQRCode.selectValue) {
        let scanService = undefined;

        forEach(groupSubscriptionServices, (groupSubscriptionService) => {
          scanService = find(groupSubscriptionService, (service) => {
            return (
              parseInt(service.id, 10) ===
              parseInt(memberQRCode.selectValue, 10)
            );
          });

          if (scanService) {
            return false;
          }
        });

        if (scanService) {
          handleSelectService(scanService);
        }
      }
    }
  }, [qrcode, groupSubscriptionServices]);

  const handleSelectService = (service) => {
    setSelectedService(service);
    setPageStep('detail');
  };

  const cancelSelected = () => {
    setSelectedService(undefined);
    setPageStep('select');
  };

  const subscription = (serviceId) => {
    setIsLoading(true);

    subscriptionAPI
      .subscriptionService(serviceId, member.userId)
      .then(
        (response) => {
          setPageStep('done');
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={classes.root}>
      <div>
        <h2>訂閱服務</h2>
        {member && (
          <div>
            <div className={classes.memberInfoRow}>
              <div>會員</div>
              <div>{member.contact}</div>
            </div>
            <div className={classes.memberInfoRow}>
              <div>UserID</div>
              <div>{member.userId}</div>
            </div>
            <div className={classes.memberInfoRow}>
              <div>會員類型</div>
              <div>
                <Chip
                  color={member.isPayingMember ? 'secondary' : 'default'}
                  size="small"
                  label={member.isPayingMember ? 'VIP會員' : '一般會員'}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <Divider />

      {pageStep === 'select' && (
        <div className={classes.subscriptionServices}>
          {isLoading && (
            <div>
              <CircularProgress />
              <div>讀取中</div>
            </div>
          )}

          {!isLoading && groupSubscriptionServices && (
            <div>
              {Object.keys(groupSubscriptionServices).map((typeCode) => (
                <div key={typeCode}>
                  <h3>{SubscriptionServiceTypeCodeText[typeCode]}</h3>
                  <div className={classes.groupServices}>
                    {groupSubscriptionServices[typeCode].map((service) => {
                      return (
                        <Button
                          key={service.id}
                          variant="contained"
                          color="primary"
                          startIcon={
                            service.imageUrl ? (
                              <Avatar src={service.imageUrl} />
                            ) : (
                              <Avatar>
                                <ImageRoundedIcon />
                              </Avatar>
                            )
                          }
                          onClick={() => {
                            handleSelectService(service);
                          }}>
                          {service.serviceName}
                        </Button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {pageStep === 'detail' && (
        <SubscriptionServiceCard
          service={selectedService}
          isPayingMember={member.isPayingMember}
          isLoading={isLoading}
          cancelSelected={cancelSelected}
          subscriptionActive={subscription}
        />
      )}

      {pageStep === 'done' && <Alert severity="success">訂閱完成!</Alert>}
    </div>
  );
};

export default SubscriptionServices;
